import React, { useEffect, useState }  from 'react';
import { TextField,
         Radio,
         RadioGroup,
         FormControl,
         FormControlLabel,
         MenuItem        } from '@material-ui/core';
import ItemFormStyles       from './styles';
import FormPageHeader       from '../../../../../components/shared/FormPageHeader';
import ExpandMoreIcon       from '@material-ui/icons/ExpandMore';
import { useFormik }        from 'formik';
import { Tax, Type, Unit  } from '../../../../../common/common.model';
import itemValidation       from  './validation'
import * as itemService     from  '../items.service';
import { Item             } from '../items.model';
import {showErrorSnackbar, showSnackbar,
       showSuccessSnackbar
                          } from '../../../../../common/common.service';
import { useSnackbar      } from 'notistack';
import Loading from '../../../../../components/shared/Loading';


const inputProps = {
  disableUnderline:true,
  style:{
    fontSize:'14px'
  }
  };

export default function(props: any): JSX.Element {
  const snackbar = useSnackbar();
 const classes = ItemFormStyles();
 let [ editMode, setEditMode]   =   useState(false);
 let [loading, setLoading]   =   useState(false);
 const [ patch, setPatch ] = useState(false);
 const formik               = useFormik({
   initialValues            : {
     name                    : '',
     type                   : Type.Goods,
     sku                    : '',
     unit                   : Unit.KG,
     rate                   : 0,
     tax                    : Tax.GST18,
     hsnCode                : ''
   },
   validateOnChange: false,
   validationSchema         : itemValidation,
   onSubmit                 : (value) =>{
    setLoading(true);
    if(editMode){
      setEditMode(false);
      itemService.editItem(props.match.params.id, new Item(value)).then(data => {
        setLoading(false);
        showSuccessSnackbar(snackbar, 'Item updated successfully!', true)
        formik.resetForm();
        setEditMode(false)
        props.history.push('/dashboard/items')
      }).catch(()=>{
        setLoading(false);
        showErrorSnackbar(snackbar, 'Something went wrong!', true)
      })

    } else {
      itemService.addItem(new Item(value)).then(data=>{  
        setLoading(false);
        showSuccessSnackbar(snackbar, 'Item saved successfully!', true)     
        formik.resetForm();
        props.history.push('/dashboard/items')
      }).catch(()=>{
        setLoading(false);
        showErrorSnackbar(snackbar, 'Something went wrong!', true)
      })
    } 
   
   }
 })


 const patchValue = async (id: string) => {  
  setPatch(true);
  setLoading(true);
  setEditMode(true);
  // const item = await itemService.getItem(id); 
  itemService.getItem(id, (item: Item) => {
    formik.setValues(item);
    setLoading(false);
    setPatch(false);
  });
}


 useEffect(()=>{
   if(props) {
    if(!props.match.url.endsWith('new')) {
      patchValue(props.match.params.id);
    }    
   }
 }, [])
 const handleCancel = () => {
  showSnackbar(snackbar, 'Cancelled!', true);
  props.history.push('/dashboard/items')
}

console.log(patch ? 'Loading': 'Saving')
  return (
    <div className={classes.main}>
      <header className={classes.header}>
        <FormPageHeader title="Add Item" update={editMode} saveHandler={formik.handleSubmit} cancelHandler={handleCancel}/>
      </header>


      <form className={classes.body}>
        <div className={classes.typebottom} style={{color:"#112B42"}}>Type <br/>
          <FormControl component="fieldset">
            <RadioGroup row aria-label="position" name="position" defaultValue="top">
              <FormControlLabel control={<Radio color="secondary"  size="small" />} label="Goods"
              { ...formik.getFieldProps('type') }
              value={Type.Goods}
              checked = {formik.getFieldProps('type').value === Type.Goods}

              />
              <FormControlLabel control={<Radio color="secondary"  size="small" />} label="Service"
               { ...formik.getFieldProps('type') }
               value={Type.Service}
               checked = {formik.getFieldProps('type').value === Type.Service}
                />
            </RadioGroup>
            <label htmlFor="" style={{color:"#7F7F7F"}}>{ formik.touched.type && formik.errors.type ? <span>{formik.errors.type}</span> : null }</label><br/>

          </FormControl>
        </div>


        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label} style={{color:"#112B42"}}>Name { formik.touched.name && formik.errors.name ? <span>{formik.errors.name}</span> : null } </label><br/>
            <TextField InputProps={inputProps} className={classes.textfield} onFocus={(e: any) => e.target.select()} { ...formik.getFieldProps('name') } /><br/>
            <label htmlFor="" style={{color:"#7F7F7F"}}> </label><br/>
          </div>
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label} style={{color:"#7f7f7f"}}>SKU { formik.touched.sku && formik.errors.sku ? <span>{formik.errors.sku}</span> : null }</label><br/>
            <TextField InputProps={inputProps} className={classes.textfield} onFocus={(e: any) => e.target.select()} { ...formik.getFieldProps('sku') }/><br/>
            <label htmlFor="" style={{color:"#7F7F7F"}}></label><br/>

          </div>
        </div>

        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}style={{color:"#7f7f7f"}}>Unit {formik.touched.unit && formik.errors.unit ? <span>{formik.errors.unit}</span> : null }</label><br/>
            {/* <TextField InputProps={inputProps} className={classes.textfield} /><br/> */}
            <TextField className={classes.taxdrop} InputProps={inputProps} select SelectProps={{IconComponent: (props) => <ExpandMoreIcon {...props}/>}}
             { ...formik.getFieldProps('unit') }>
                <MenuItem value={Unit.KG}>{Unit.KG}</MenuItem>
                <MenuItem value={Unit.BAG}>{Unit.BAG}</MenuItem>
              </TextField><br/>

          </div>
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}style={{color:"#7f7f7f"}}>Rote { formik.touched.rate && formik.errors.rate ? <span>{formik.errors.rate}</span> : null } </label><br/>
            <TextField type="number" InputProps={inputProps} onFocus={(e: any) => e.target.select()} className={classes.textfield} { ...formik.getFieldProps('rate') } /><br/>
            <label htmlFor="" style={{color:"#7F7F7F"}}></label><br/>

          </div>
        </div>

        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label} style={{color:"#7f7f7f"}}>Tax(%) { formik.touched.tax && formik.errors.tax ? <span>{formik.errors.tax}</span> : null } </label><br/>
             <TextField className={classes.taxdrop} InputProps={inputProps} select SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
             { ...formik.getFieldProps('tax') }>
                <MenuItem value={Tax.GST18}>{Tax.GST18}</MenuItem>
                <MenuItem value={Tax.GST5}>{Tax.GST5}</MenuItem>
                <MenuItem value={Tax.GST0}>{Tax.GST0}</MenuItem>
              </TextField><br/>

          </div>
        <div className={classes.column1}>
            <label htmlFor="" className={classes.label} style={{color:"#7f7f7f"}}>HSN Code { formik.touched.hsnCode && formik.errors.hsnCode ? <span>{formik.errors.hsnCode}</span> : null } </label><br/>
            <TextField InputProps={inputProps} onFocus={(e: any) => e.target.select()} className={classes.textfield} { ...formik.getFieldProps('hsnCode') } /><br/>
        </div>
        </div>

      </form>
      <Loading loading={loading} text={patch ? 'Loading....': null}/>
    </div>

  );
}